export const CloseCircleIcon = ({
  strokeColor = "var(--color-bg-primary)",
  ...props
}: any) => (
  <svg {...props} width="22" height="22" viewBox="0 0 22 22" fill="none">
    <g id="vuesax/linear/close-circle">
      <g id="close-circle">
        <path
          id="Vector"
          d="M10.9997 20.1654C16.0413 20.1654 20.1663 16.0404 20.1663 10.9987C20.1663 5.95703 16.0413 1.83203 10.9997 1.83203C5.95801 1.83203 1.83301 5.95703 1.83301 10.9987C1.83301 16.0404 5.95801 20.1654 10.9997 20.1654Z"
          stroke={strokeColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M8.40625 13.5946L13.5946 8.40625"
          stroke={strokeColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M13.5946 13.5946L8.40625 8.40625"
          stroke={strokeColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);
